export const shouldLockContextField = (
  contextValue?: string | null,
  selectedValue?: string | null
) => !!contextValue && !!selectedValue && contextValue === selectedValue;
